import store from '@/state/store'

const fields = [
  {
    key: 'vehicle',
    label: 'global.object.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
    isObject: true,
  },
  {
    key: 'driver',
    label: 'global.object.driver',
    header: 'driver',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'totalDistance',
    label: 'report.fields.totalDistance',
    header: 'totalDistance',
    filter: false,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'driverBehavior',
    label: 'global.alert.type.driverBehavior',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'HARSH_ACCELERATION',
        label: 'global.alert.suddenAcceleration',
        header: 'harshAccels',
        alertCode: 24,
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 1,
      },
      {
        key: 'HARSH_BRAKING',
        label: 'global.alert.suddenDeceleration',
        header: 'harshBraking',
        alertCode: 23,
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
      },
      {
        key: 'OVERSPEED',
        label: 'global.alert.overspeed',
        header: 'overspeed',
        alertCode: 8,
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
      },
      {
        key: 'SHARP_TURN',
        label: 'global.alert.sharpTurn',
        header: 'sharpTurns',
        alertCode: 25,
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
      },
    ],
    headerColspan: 4,
  },
]
let childOfIndex = 0
if (store.getters['identity/hasAccess'](['raw_alerts_dms:read'])) {
  childOfIndex++
  fields.splice(4, 0, {
    key: 'dms',
    label: 'global.alert.type.dms',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'YAWN',
        label: 'global.alert.yawning',
        header: 'yawn',
        alertCode: 53,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 1,
      },
      {
        key: 'DISTRACTION',
        label: 'global.alert.disturbance',
        header: 'distraction',
        alertCode: 52,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'SMOKING',
        label: 'global.alert.smoking',
        header: 'smoking',
        alertCode: 54,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'PHONE_CALLING',
        label: 'global.alert.calling',
        header: 'phoneCalling',
        alertCode: 55,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'EYE_CLOSED',
        label: 'global.alert.asleep',
        header: 'eyeClosed',
        alertCode: 51,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'MISSING_FACE',
        label: 'global.alert.outOfFrame',
        header: 'missingFace',
        alertCode: 56,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'CRASH',
        label: 'global.alert.crash',
        header: 'crash',
        alertCode: 49,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
    ],
    headerColspan: 7,
  })
}

childOfIndex++
fields.push({
  key: 'general',
  label: 'global.alert.type.general',
  filter: false,
  width: 30,
  isLocked: true,
  children: [
    {
      key: 'SOS_SENT',
      label: 'global.alert.sosButton',
      header: 'sosSent',
      alertCode: 11,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 1,
    },
    {
      key: 'DEVICE_DISARMED',
      label: 'global.alert.gpsDisarmed',
      header: 'disarm',
      alertCode: 1,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'TEMPERATURE_1',
      label: 'global.alert.temp1',
      header: 'temp1',
      alertCode: 18,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'TEMPERATURE_2',
      label: 'global.alert.temp2',
      header: 'temp2',
      alertCode: 17,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'GSM_SIGNAL_WEAK',
      label: 'global.alert.gpsWeakSignal',
      header: 'gpsWeakSignal',
      alertCode: 3,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'VIBRATION',
      label: 'global.alert.vibration',
      header: 'vibration',
      alertCode: 10,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'ENGINE_ON',
      label: 'report.fields.engineOn',
      header: 'engineOn',
      alertCode: 12,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'ENGINE_OFF',
      label: 'report.fields.engineOff',
      header: 'engineOff',
      alertCode: 12,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'ENTER_GEOFENCE',
      label: 'report.fields.enterGeofence',
      header: 'enterGeofence',
      alertCode: 7,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'EXIT_GEOFENCE',
      label: 'report.fields.exitGeofence',
      header: 'exitGeofence',
      alertCode: 7,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'PTO_ON',
      label: 'report.fields.ptoOn',
      header: 'ptoOn',
      alertCode: 62,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
    {
      key: 'PTO_OFF',
      label: 'report.fields.ptoOff',
      header: 'ptoOff',
      alertCode: 63,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    },
  ],
  headerColspan: 12,
})

if (store.getters['identity/hasAccess'](['teltonika-device:read'])) {
  const general = fields.findIndex((item) => item.key === 'general')
  fields[general].children.splice(13, 0, {
    key: 'CRASH_DETECTION',
    label: 'global.alert.crashDetection',
    header: 'crashDetection',
    alertCode: [94, 95],
    headerColspan: 1,
    childOfIndex: childOfIndex,
    isTopHead: 0,
  })
  fields[general].headerColspan += 1
}

if (store.getters['identity/hasAccessAll'](['seat_belt_alert:read', 'raw_alerts_dms:read'])) {
  const dms = fields.findIndex((item) => item.key === 'dms')
  fields[dms].children.push({
    key: 'SEATBELT',
    label: 'global.alert.seatbelt',
    header: 'seatbelt',
    alertCode: 110,
    headerColspan: 1,
    childOfIndex: 1,
    isTopHead: 0,
  })
  fields[dms].headerColspan += 1
}
if (store.getters['identity/hasAccessAll'](['fatigue_driving_alert:read', 'raw_alerts_dms:read'])) {
  const dms = fields.findIndex((item) => item.key === 'dms')
  fields[dms].children.push({
    key: 'FATIGUE_DRIVING',
    label: 'global.alert.fatigueDriving',
    header: 'fatigueDriving',
    alertCode: 50,
    headerColspan: 1,
    childOfIndex: 1,
    isTopHead: 0,
  })
  fields[dms].headerColspan += 1
}
if (
  store.getters['identity/hasAccessAll'](['infrared_blocked_alert:read', 'raw_alerts_dms:read'])
) {
  const dms = fields.findIndex((item) => item.key === 'dms')
  fields[dms].children.push({
    key: 'INFRARED_BLOCKED',
    label: 'global.alert.infraredBlocked',
    header: 'infraredBlocked',
    alertCode: 111,
    headerColspan: 1,
    childOfIndex: 1,
    isTopHead: 0,
  })
  fields[dms].headerColspan += 1
}
if (store.getters['identity/hasAccess'](['raw_alerts_adas:read'])) {
  childOfIndex++
  fields.splice(7, 0, {
    key: 'adas',
    label: 'global.alert.type.adas',
    filter: false,
    width: 30,
    isLocked: true,
    children: [
      {
        key: 'FORWARD_COLLISION_WARNING',
        label: 'global.alert.forwardCollison',
        header: 'forwardCollision',
        alertCode: 90,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 1,
      },
      {
        key: 'LANE_DEPARTURE_WARNING',
        label: 'global.alert.laneDeparture',
        header: 'laneDeparture',
        alertCode: 92,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'HEADWAY_MONITOR_WARNING',
        label: 'global.alert.headwayMonitor',
        header: 'headwayMonitor',
        alertCode: 91,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
      {
        key: 'HUMAN_DETECTION',
        label: 'global.alert.humanDetection',
        header: 'humanDetection',
        alertCode: 134,
        headerColspan: 1,
        childOfIndex: childOfIndex,
        isTopHead: 0,
      },
    ],
    headerColspan: 4,
  })

  if (store.getters['identity/hasAccess'](['e1l-adas-human-detection:read'])) {
    const adas = fields.findIndex((item) => item.key === 'adas')
    fields[adas].children.push({
      key: 'HUMAN_DETECTION',
      label: 'global.alert.humanDetection',
      header: 'humanDetection',
      alertCode: 134,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    })
    fields[adas].headerColspan += 1
  }

  if (store.getters['identity/hasAccess'](['front_object_detected_alert:read'])) {
    const adas = fields.findIndex((item) => item.key === 'adas')
    fields[adas].children.push({
      key: 'FRONT_OBJECT_DETECTED',
      label: 'global.alert.frontObjectDetected',
      header: 'frontObjectDetected',
      alertCode: 113,
      headerColspan: 1,
      childOfIndex: childOfIndex,
      isTopHead: 0,
    })
    fields[adas].headerColspan += 1
  }
}

export default fields
